module.exports = __webpack_public_path__ + "media/images/riders/small/EMILY_BATTY-0731d2cc8cce134e5dfff9ab31488c4c.png";